import { render, staticRenderFns } from "./materialLibrary.vue?vue&type=template&id=38c17299&scoped=true"
import script from "./materialLibrary.vue?vue&type=script&lang=js"
export * from "./materialLibrary.vue?vue&type=script&lang=js"
import style0 from "./materialLibrary.vue?vue&type=style&index=0&id=38c17299&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c17299",
  null
  
)

export default component.exports